// export DsfMessageNotification from './messageNotification.vue'

export const DsfMessageNotification = dsf.defineAsyncComponent("DsfMessageNotification", () => import(/*webpackChunkName:"platform_pc_homepage"*/ "./messageNotification.vue"));

export const DsfMessageNotificationSetting = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_homepage" */ "./messageNotificationSetting.vue"));

